import TronWeb from "tronweb";
export const tronWeb = new TronWeb({
  fullHost: "https://api.trongrid.io",
});
window.tronWeb1 = tronWeb;
